"use client";

import { memo } from "react";

export const ShimmerDots = memo(function ShimmerDots() {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Dot grid pattern - pure CSS, no JS */}
      <div 
        className="absolute inset-0 opacity-[0.15]" 
        style={{
          backgroundImage: `radial-gradient(circle at center, hsl(var(--primary)) 1px, transparent 1px)`,
          backgroundSize: '40px 40px'
        }} 
      />
    </div>
  );
});